import NotFoundBg from '@/assets/not-found.png';
import JenLogo from '@/assets/jen-logo-orange.png';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="p-[16px] w-full h-full bg-[#161616] text-white  flex flex-col justify-between">
      <div>
        <div
          style={{
            background: `url(${JenLogo}) 0% 0% / cover no-repeat`,
          }}
          className="w-[69px] h-[48px]"
        ></div>
        <div className="mt-[62px] m-auto text-[18px]">
          <div className="text-center">Page Not Found</div>
          <div
            onClick={handleGoBack}
            className="w-fit mx-auto mt-[12px] flex justify-center items-center gap-[10px] text-jen-orange hover:underline cursor-pointer"
          >
            <div className="w-[28px] h-[28px] flex justify-center items-center rounded-full bg-jen-orange ">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                <path d="M12 7H2M2 7L7.88889 1M2 7L7.88889 13" stroke="#161616" stroke-width="2" />
              </svg>
            </div>
            Go Back
          </div>
        </div>
      </div>

      <div
        className="w-[75vw] mx-auto "
        style={{
          background: `url(${NotFoundBg}) 0% 0% / cover no-repeat`,
        }}
      >
        <div className="w-full" style={{ paddingTop: '42.5%' }}></div>
      </div>
    </div>
  );
};

export default NotFound;
